// eslint-disable-next-line import/prefer-default-export
export const TASK_STATUSES = {
  RECEIVED: 'RECEIVED',
  STARTED: 'STARTED',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  RETRY: 'RETRY',
  REVOKED: 'REVOKED',
};
